import { createAction, props } from '@ngrx/store';

import { Feature } from '@vi-iot/client';

export namespace GatewayActions {
  export enum Type {
    FETCH_FEATURE = '[GATEWAY] Fetch Feature',
    FETCH_FEATURE_SUCCESS = '[GATEWAY] Fetch Feature Success',
    FETCH_FEATURE_ERROR = '[GATEWAY] Fetch Feature Error',
  }

  export const FetchFeature = createAction(Type.FETCH_FEATURE, props<{ featureName: string }>());

  export const FetchFeatureSuccess = createAction(
    Type.FETCH_FEATURE_SUCCESS,
    props<{ features: Feature<unknown, unknown>[] }>()
  );

  export const FetchFeatureError = createAction(Type.FETCH_FEATURE_ERROR);
}
